import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  Form,
  Input,
  Button,
  Card,
  Typography,
  Select,
  message
} from 'antd';
import {
  UserOutlined,
  LockOutlined,
  MailOutlined,
  IdcardOutlined
} from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { registerUser } from '../redux/authSlice';
import '../styles/Register.module.css';

const { Title, Text } = Typography;
const { Option } = Select;

const Register = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await dispatch(registerUser(values)).unwrap();
      message.success('Регистрация прошла успешно!');
    } catch (err) {
      message.error(err || 'Ошибка при регистрации');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <Card className="register-card" style={{ width: "40%", display: 'block', marginLeft: 'auto', marginRight: 'auto' }}>
        <div className="register-header">
          <Title level={3} className="register-title">
            Регистрация
          </Title>
          <Text type="secondary">Создайте новый аккаунт</Text>
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          className="register-form"
        >
          <Form.Item
            name="username"
            label="Имя пользователя"
            rules={[
              { required: true, message: 'Пожалуйста, введите имя пользователя' },
              { min: 4, message: 'Минимум 4 символа' }
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="username"
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="Пароль"
            rules={[
              { required: true, message: 'Пожалуйста, введите пароль' },
              { min: 6, message: 'Минимум 6 символов' }
            ]}
            hasFeedback
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="••••••"
            />
          </Form.Item>

          <Form.Item
            name="confirm"
            label="Подтверждение пароля"
            dependencies={['password']}
            hasFeedback
            rules={[
              { required: true, message: 'Пожалуйста, подтвердите пароль' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Пароли не совпадают!'));
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="••••••"
            />
          </Form.Item>

          <Form.Item
            name="first_name"
            label="Имя"
            rules={[
              { required: true, message: 'Пожалуйста, введите ваше имя' }
            ]}
          >
            <Input
              prefix={<IdcardOutlined />}
              placeholder="Иван"
            />
          </Form.Item>

          <Form.Item
            name="last_name"
            label="Фамилия"
            rules={[
              { required: true, message: 'Пожалуйста, введите вашу фамилию' }
            ]}
          >
            <Input
              prefix={<IdcardOutlined />}
              placeholder="Иванов"
            />
          </Form.Item>

          <Form.Item
            name="email"
            label="Email"
            rules={[
              {
                required: true,
                message: 'Пожалуйста, введите ваш email'
              },
              {
                type: 'email',
                message: 'Введите корректный email'
              }
            ]}
          >
            <Input
              prefix={<MailOutlined />}
              placeholder="example@mail.com"
            />
          </Form.Item>

          <Form.Item
            name="role"
            label="Роль"
            initialValue="user"
          >
            <Select>
              <Option value="user">Пользователь</Option>
              <Option value="admin">Администратор</Option>
            </Select>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={loading}
            >
              Зарегистрироваться
            </Button>
          </Form.Item>
        </Form>
        <div style={{ textAlign: 'center' }}>
          <Text>Уже есть аккаунта </Text>
          <Link to="/login">Вход</Link>
        </div>

      </Card>
    </div>
  );
};

export default Register;